'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowUpOnSquareIcon } from '@heroicons/react/24/outline';
import { motion, useAnimationControls } from 'motion/react';
import { useCallback } from 'react';
import { copyLink } from '@src/components/ContentShareModal/util';
import { useLocale } from '@src/i18n/LocaleProvider';
import { cn } from '@src/utils/tailwind';
type ShareButtonProps = {
  shareUrl?: string;
  title?: string;
  tone?: 'dark' | 'light';
  className?: string;
  onShareClick?: (sharePlatform: 'copy link' | 'native mobile share') => void;
  'data-testid'?: string;
};
export const ShareButton = t0 => {
  const $ = _c(22);
  const {
    shareUrl,
    title: t1,
    tone: t2,
    className,
    onShareClick,
    "data-testid": t3
  } = t0;
  const title = t1 === undefined ? "" : t1;
  const tone = t2 === undefined ? "dark" : t2;
  const dataTestId = t3 === undefined ? "tile_button_share" : t3;
  const {
    t: tCommon
  } = useLocale("common");
  const controls = useAnimationControls();
  let t4;
  if ($[0] !== controls || $[1] !== onShareClick || $[2] !== shareUrl || $[3] !== title) {
    t4 = ev => {
      ev.stopPropagation();
      if (!shareUrl) {
        return;
      }
      controls.start({
        scale: [1, 0.85, 1.15, 1],
        transition: {
          duration: 0.35,
          times: [0, 0.2, 0.65, 1],
          ease: "easeOut"
        }
      });
      if (typeof navigator.share === "function") {
        onShareClick?.("native mobile share");
        navigator.share({
          title,
          url: shareUrl
        })?.catch(() => {
          copyLink({
            url: shareUrl
          });
        });
      } else {
        onShareClick?.("copy link");
        copyLink({
          url: shareUrl
        });
      }
    };
    $[0] = controls;
    $[1] = onShareClick;
    $[2] = shareUrl;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleShareClick = t4;
  if (!shareUrl) {
    return null;
  }
  const iconClass = tone === "light" ? "h-6 w-6 text-bodi-black-text" : "h-6 w-6 text-bodi-white";
  const t5 = tone === "light" && "cursor-pointer";
  let t6;
  if ($[5] !== className || $[6] !== t5) {
    t6 = cn("flex h-10 w-10 items-center justify-center rounded-full border border-bodi-gray-medium", t5, className);
    $[5] = className;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== tCommon) {
    t7 = tCommon("share");
    $[8] = tCommon;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      scale: 1
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== iconClass) {
    t9 = <ArrowUpOnSquareIcon className={iconClass} />;
    $[11] = iconClass;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== controls || $[14] !== t9) {
    t10 = <motion.span className="inline-flex" animate={controls} initial={t8}>{t9}</motion.span>;
    $[13] = controls;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== dataTestId || $[17] !== handleShareClick || $[18] !== t10 || $[19] !== t6 || $[20] !== t7) {
    t11 = <button type="button" className={t6} onClick={handleShareClick} aria-label={t7} data-testid={dataTestId}>{t10}</button>;
    $[16] = dataTestId;
    $[17] = handleShareClick;
    $[18] = t10;
    $[19] = t6;
    $[20] = t7;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};